/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ApolloClient } from "@apollo/client";
import { getOperationName } from "@apollo/client/utilities";

const failedMutationNames = new WeakMap<object, string>();

export const failedMutationName = (error: unknown) =>
  typeof error === "object" && error
    ? failedMutationNames.get(error)
    : undefined;

// An ApolloError doesn't say which operation failed. A batch shares one network
// error between its operations, so the name is noted here, per mutate call, and not
// in a link.
export function nameFailedMutations(client: ApolloClient<any>) {
  const { mutate } = client;

  client.mutate = ((options: Parameters<typeof mutate>[0]) =>
    mutate(options).catch((error: unknown) => {
      const name = getOperationName(options.mutation);
      if (name && typeof error === "object" && error) {
        failedMutationNames.set(error, name);
      }
      throw error;
    })) as typeof client.mutate;
}
